import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import CveTipDivOUtilOptions from '../../support/catalogos/dividendos/CveTipDivOUtilOptions';
import TipoSocDistrDivOptions from '../../support/catalogos/dividendos/TipoSocDistrDivOptions';
import ComplementoDividendosRules from '../../support/rules/complementos/ComplementoDividendosRules.js';

const rules = ComplementoDividendosRules;

const ComplementoDividendos = (props) => {
  const [data, setData] = useState(props.data || {});

  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnDividOUtilChange = (event) => {
    const { DividOUtil = {} } = data;

    const newData = {
      ...data,
      DividOUtil: {
        ...DividOUtil,
        ...event
      }
    };

    setData(newData);
  };

  const handleOnRemanenteChange = (event) => {
    const { Remanente = {} } = data;

    const newData = {
      ...data,
      Remanente: {
        ...Remanente,
        ...event
      }
    };

    setData(newData);
  }

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => {
    validate(data);
  }, [data]);

  const handleOnComplementoAdd = () => {
    const Dividendos = {
      Version: '1.0',
      ...data
    };

    props.onChange({ Dividendos });

    clear();
  };

  const handleOnCancel = () => {
    props.onChange({ Dividendos: undefined });
  };

  const clear = () => {
    setData({});
  };

  const { DividOUtil = {}, Remanente = {} } = data;

  return (
    <div className="pb-4">
      <div>
          <strong className="text-black text-upper">Dividendos</strong>
      </div>
      <div className="section">
        <Form autoComplete="off">
          <Row>
            <Col sm md={4}>
              <FormControl
                type="select"
                label="Clave"
                name="CveTipDivOUtil"
                placeholder=""
                help=""
                options={CveTipDivOUtilOptions}
                rules={rules.DividOUtil.CveTipDivOUtil}
                value={DividOUtil.CveTipDivOUtil}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Importe acreditado México"
                name="MontISRAcredRetMexico"
                placeholder=""
                help=""
                rules={rules.DividOUtil.MontISRAcredRetMexico}
                value={DividOUtil.MontISRAcredRetMexico}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Importe acreditado Extranjero"
                name="MontISRAcredRetExtranjero"
                placeholder=""
                help=""
                rules={rules.DividOUtil.MontISRAcredRetExtranjero}
                value={DividOUtil.MontISRAcredRetExtranjero}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Monto retención Extranjero"
                name="MontRetExtDivExt"
                placeholder=""
                help=""
                rules={rules.DividOUtil.MontRetExtDivExt}
                value={DividOUtil.MontRetExtDivExt}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="select"
                label="Tipo sociedad"
                name="TipoSocDistrDiv"
                placeholder=""
                help=""
                options={TipoSocDistrDivOptions}
                rules={rules.DividOUtil.TipoSocDistrDiv}
                value={DividOUtil.TipoSocDistrDiv}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="ISR acreditable nacional"
                name="MontISRAcredNal"
                placeholder=""
                help=""
                rules={rules.DividOUtil.MontISRAcredNal}
                value={DividOUtil.MontISRAcredNal}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Monto acumulable nacional"
                name="MontDivAcumNal"
                placeholder=""
                help=""
                rules={rules.DividOUtil.MontDivAcumNal}
                value={DividOUtil.MontDivAcumNal}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Monto acumulable extranjero"
                name="MontDivAcumExt"
                placeholder=""
                help=""
                rules={rules.DividOUtil.MontDivAcumExt}
                value={DividOUtil.MontDivAcumExt}
                onChange={handleOnDividOUtilChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Remanente"
                name="ProporcionRem"
                placeholder=""
                help=""
                rules={rules.Remanente.ProporcionRem}
                value={Remanente.ProporcionRem}
                onChange={handleOnRemanenteChange}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                variant="secondary"
                className="mr-2"
                onClick={handleOnCancel}
              >
                Cancelar
              </Button>

              <Button
                variant="primary"
                disabled={!isValid}
                onClick={handleOnComplementoAdd}
              >
                Agregar complemento
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ComplementoDividendos;
